import { GlobalSettingEnum } from 'api/model';
import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';
import useGlobalSettings from './useGlobalSettings';

/**
 * Feature toggle for the Sharebox pilot (GlobalSettingEnum.UsersWithAccessToSharebox).
 * Empty list = off for everyone — the feature must be enabled explicitly.
 *
 * Gates what is SHOWN, not what is stored: the mirror and the key CaseEvents are
 * written regardless, so history is complete from day one for users added later.
 * The backend enforces the same list on GetCaseKeyStatus and on the FT pushes —
 * this hook only keeps the UI from asking for and rendering data it may not show.
 */
const useHasAccessToSharebox = () => {
  const me = useMe();
  const { parsedData: globalSettings, loaded } = useGlobalSettings();

  const hasAccess = useMemo(() => {
    if (!me || !loaded) {
      return false;
    }

    const allowedUsers =
      globalSettings[GlobalSettingEnum.UsersWithAccessToSharebox];

    const hasAnyUsers = Object.keys(allowedUsers).length > 0;
    if (!hasAnyUsers) {
      return false;
    }

    return allowedUsers[me.userID] === true;
  }, [me, globalSettings, loaded]);

  return hasAccess;
};

export default useHasAccessToSharebox;
